import React from "react";
import { Grid, Stack, Box } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import FormTextField from "../components/common/FormTextField";
import SubmitButton from "../components/buttons/SubmitButton";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

import { createProduct, updateProduct } from "../redux/actions/productActions";
import { cleanFormData } from "../helpers/formHelpers";

const productSchema = Yup.object({
  name: Yup.string().required("Product name is required"),
  description: Yup.string().nullable(),
  eTimsNarration: Yup.string().nullable(),
});

const CreateOrUpdateProductForm = ({
  product = null,
  isEditing = false,
  loading = false,
}) => {
  const dispatch = useDispatch();

  const initialValues = {
    name: product?.name || "",
    description: product?.description || "",
    eTimsNarration: product?.eTimsNarration || "",
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={productSchema}
      onSubmit={(values) => {
        const cleanedValues = cleanFormData(values);
        if (isEditing) {
          dispatch(updateProduct({ id: product.id, values: cleanedValues }));
        } else {
          dispatch(createProduct(cleanedValues));
        }
      }}
      enableReinitialize
    >
      {({ dirty, isValid }) => (
        <Form>
          <Stack spacing={3}>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormTextField
                    name="name"
                    label="Product Name"
                    placeholder="e.g. ERP License - Standard"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormTextField
                    name="description"
                    label="Description"
                    multiline
                    rows={2}
                    placeholder="Brief details about the product..."
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormTextField
                    name="eTimsNarration"
                    label="eTIMS Narration"
                    placeholder="Standard narration for tax invoicing"
                  />
                </Grid>
              </Grid>
            </Box>

            <SubmitButton
              title={isEditing ? "Update Product" : "Register Product"}
              loading={loading}
              disabled={!dirty || !isValid || loading}
              startIcon={
                isEditing ? <SaveOutlinedIcon /> : <AddCircleOutlineIcon />
              }
              sx={{ mt: 1 }}
            />
          </Stack>
        </Form>
      )}
    </Formik>
  );
};

export default CreateOrUpdateProductForm;
